<div class="loader" *ngIf="httpMonitor.getPendingRequests() > 0">
    <img src="/assets/images/preloader.gif" alt="">
</div>
<div id="preloader" class="loader">
    <img src="/assets/images/preloader.gif" alt="">
</div>

<cc-header></cc-header>
<div class="route-container">
    <router-outlet></router-outlet>
</div>
<cc-footer></cc-footer>